var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-tab"},[_c('i',{class:_vm.icon}),(_vm.heading)?_c('span',{staticClass:"ml-3",domProps:{"innerHTML":_vm._s(_vm.heading)}},[_vm._v("My Coupons")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }